import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Form as AntdForm } from 'antd';
import { CollapseBlock } from '../../../common';
import FormTextField from '../../../antd/form/FormTextField/FormTextField';
import FormTextArea from '../../../antd/form/FormTextArea/FormTextArea';
import FormTextEditor from '../../../antd/form/FormTextEditor/FormTextEditor';
import FormSelect from '../../../antd/form/FormSelect/FormSelect';
import FormNumberField from '../../../antd/form/FormNumberField/FormNumberField';
import FormDate from '../../../antd/form/FormDate/FormDate';
import FormSwitch from '../../../antd/form/FormSwitch/FormSwitch';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import FormButton from '../../../antd/form/FormButton/FormButton';

const componentMap = {
  text: FormTextField,
  textarea: FormTextArea,
  editor: FormTextEditor,
  select: FormSelect,
  number: FormNumberField,
  date: FormDate,
  switch: FormSwitch,
};

const SchoolYearFieldRenderer = ({ field }) => {
  const { t } = useTranslation();
  const form = AntdForm.useFormInstance();
  const value = AntdForm.useWatch(field.name, form);

  useEffect(() => {
    if (value) {
      return;
    }

    const currentOption = (field.options || []).find(
      (option) => option.isCurrent,
    );
    if (currentOption) {
      form.setFieldValue(field.name, currentOption.value);
    }
  }, [field.name, field.options, form, value]);

  const props = {
    label: field.label,
    name: field.name,
    rules: field.rules,
    options: field.options || [],
    ...field.componentProps,
  };
  props.disabled = true;
  props.extra = t(
    'Školský rok určuje server. Pri historickom zázname je hodnota iba na čítanie.',
  );
  delete props.onChange;
  delete props.loading;

  return <FormSelect {...props} />;
};

const FieldRenderer = ({ field }) => {
  if (field.hidden) {
    return null;
  }

  if (typeof field.render === 'function') {
    return field.render();
  }

  if (field.name === 'phd_school_year_id') {
    return <SchoolYearFieldRenderer field={field} />;
  }

  const Component = componentMap[field.type] || FormTextField;
  const props = {
    label: field.label,
    name: field.name,
    rules: field.rules,
    ...field.componentProps,
  };

  if (field.type === 'select') {
    props.options = field.options || [];
  }

  if ((field.type === 'number' || field.type === 'date') && !props.style) {
    props.style = { width: '100%' };
  }

  return <Component {...props} />;
};

const PhdFormBuilder = ({
  sections,
  submitKey,
  isSubmitting = false,
  isSubmitDisabled = false,
  beforeSubmitContent = null,
  hideSubmit = false,
  submitLabel = null,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {(sections || []).map((section) => (
        <CollapseBlock
          key={section.key || section.title}
          collapsible
          title={section.title}
        >
          <Row gutter={16}>
            {(section.fields || []).map((field) => (
              <Col key={field.name} xs={24} md={field.colSpan ?? 12}>
                <FieldRenderer field={field} />
              </Col>
            ))}
          </Row>
        </CollapseBlock>
      ))}
      {beforeSubmitContent}
      {!hideSubmit && (
        <FormButtonsContainer>
          <FormButton
            submitOnClick
            submitKey={submitKey}
            disabled={isSubmitting || isSubmitDisabled}
          >
            {submitLabel || t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      )}
    </>
  );
};

export default PhdFormBuilder;
